import { css } from 'styled-components';
import * as frontline from '#styles/frontline';

const AddThis = css`
  .at-share-tbx-element .at-share-btn {
    margin: 0 !important;
  }
`;

export default AddThis;
